import { Link } from "react-router-dom";

const Wordmark = ({ className = "" }) => (
  <span className={`font-display tracking-tight ${className}`}>
    <span className="text-[#221e1b]">Panch</span>
    <span className="text-[#a8792a]">maya</span>
  </span>
);

export const Brand = ({ testId = "nav-logo", onClick }) => (
  <Link to="/" onClick={onClick} data-testid={testId} className="group flex shrink-0 items-center gap-3 rounded-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-[#7a5615] sm:gap-3.5" aria-label="Panchmaya home">
    <img
      src="/panchmaya-mark-112.webp"
      width="56"
      height="56"
      alt=""
      className="h-12 w-12 shrink-0 rounded-full transition-transform duration-700 group-hover:rotate-[72deg] sm:h-14 sm:w-14"
    />
    <span className="flex flex-col">
      <Wordmark className="text-[2rem] font-semibold leading-none sm:text-[2.25rem]" />
      <span className="mt-1 whitespace-nowrap text-xs font-medium leading-snug tracking-[0.035em] text-[#7a5615] sm:text-[0.8125rem]">
        From darkness to light
      </span>
    </span>
  </Link>
);
